import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { provideConfig } from '@spartacus/core';
import { GenericLinkModule, PageSlotModule } from '@spartacus/storefront';

import { DpMyAccountComponent } from './my-account.component';

import { DpMyAccountUiComponent } from './my-account-ui/my-account-ui.component';

@NgModule({
  imports: [MatIcon, AsyncPipe, NgClass, NgTemplateOutlet, GenericLinkModule, PageSlotModule],
  exports: [DpMyAccountComponent],
  declarations: [DpMyAccountComponent, DpMyAccountUiComponent],
  providers: [provideConfig({ cmsComponents: { NavigationComponent: { component: DpMyAccountComponent } } })],
})
export class DpMyAccountModule {}
